<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-09-08 10:46:28
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-06-26 10:39:50
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/WeMeet_admin_project/wemeet-admin/src/views/userCenter/userManage/components/userDetail.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-drawer
    ref="drawerRef"
    v-model="dialogFormVisible"
    :before-close="handleClose"
    custom-class="demo-drawer userInfoDrawer"
    :direction="direction"
    :size="size"
  >
    <div class="containerForm">
      <el-descriptions border class="margin-top" title="用户基础信息">
        <el-descriptions-item label="用户名">
          <!-- {{ userBaseInfo.name }} -->
          郝伟伟
        </el-descriptions-item>

        <el-descriptions-item label="手机号">
          <!-- {{ userBaseInfo.phone }} -->
          15026906443
        </el-descriptions-item>

        <el-descriptions-item label="email">
          <!-- {{ userBaseInfo.email }} -->
          1078734933@qq.com
        </el-descriptions-item>

        <el-descriptions-item label="公司">
          {{ userBaseInfo.company }}
        </el-descriptions-item>
        <el-descriptions-item label="部门">
          {{ userBaseInfo.department }}
        </el-descriptions-item>

        <el-descriptions-item label="职位">
          {{ userBaseInfo.position }}
        </el-descriptions-item>

        <el-descriptions-item label="uid">
          {{ userBaseInfo.uid }}
        </el-descriptions-item>

        <el-descriptions-item label="用户头像">
          <el-image
            :preview-src-list="[userBaseInfo.avatar]"
            :src="userBaseInfo.avatar"
            style="width: 50px; height: 50px"
          />
        </el-descriptions-item>
      </el-descriptions>

      <el-descriptions border class="margin-top" title="用户实名信息">
        <el-descriptions-item label="用户名">
          <!-- {{ userBaseInfo.name }} -->
          郝伟伟
        </el-descriptions-item>

        <el-descriptions-item label="手机号">
          <!-- {{ userBaseInfo.phone }} -->
          15026906443
        </el-descriptions-item>

        <el-descriptions-item label="email">
          <!-- {{ userBaseInfo.email }} -->
          1078734933@qq.com
        </el-descriptions-item>
      </el-descriptions>

      <el-descriptions class="margin-top hideLabel" title="用户标签信息">
        <el-descriptions-item>
          <el-transfer
            v-model="leftValue"
            :button-texts="['取消', '保存']"
            :data="data"
            :format="{
              noChecked: '${total}',
              hasChecked: '${checked}/${total}',
            }"
            :left-default-checked="[]"
            :right-default-checked="[]"
            style="text-align: left; display: inline-block"
            :titles="['从现有标签中选择', '已选标签']"
          />
        </el-descriptions-item>
      </el-descriptions>

      <el-descriptions class="margin-top hideLabel" title="入池时间">
        <el-descriptions-item label="">
          <!-- {{ userBaseInfo.email }} -->
          1078734933@qq.com
        </el-descriptions-item>
      </el-descriptions>

      <el-descriptions class="margin-top hideLabel" title="最后互动时间">
        <el-descriptions-item label="">
          <!-- {{ userBaseInfo.email }} -->
          1078734933@qq.com
        </el-descriptions-item>
      </el-descriptions>

      <el-descriptions class="margin-top hideLabel" title="参加过的项目">
        <el-descriptions-item label="">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column label="Date" prop="date" width="180" />
            <el-table-column label="Name" prop="name" width="180" />
            <el-table-column label="Address" prop="address" />
          </el-table>
          <el-pagination
            background
            :current-page="queryForm.page"
            :layout="layout"
            :page-size="queryForm.pageSize"
            :total="total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </el-descriptions-item>
      </el-descriptions>
    </div>
  </el-drawer>
</template>
<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, ref, toRefs } from 'vue'
  export default defineComponent({
    name: 'GenerateWx',
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance()
      const state = reactive({
        dialogFormVisible: false,
        direction: 'rtl',
        size: '60%',
        title: '链接地址',
        loading: null,
        senceKey: '',
        queryForm: {
          page: 1,
          pageSize: 10,
        },
        total: 0,
        noQrCodeBox: false,
        website: '',
        h5Url: '',
        userBaseInfo: {},
        leftValue: '',
        data: [
          {
            key: 1,
            label: `1`,
          },
          {
            key: 2,
            label: `2`,
          },
          {
            key: 3,
            label: `31`,
          },
        ],
        tableData: [
          {
            date: '2016-05-03',
            name: 'Tom',
            address: 'No. 189, Grove St, Los Angeles',
          },
          {
            date: '2016-05-02',
            name: 'Tom',
            address: 'No. 189, Grove St, Los Angeles',
          },
          {
            date: '2016-05-04',
            name: 'Tom',
            address: 'No. 189, Grove St, Los Angeles',
          },
          {
            date: '2016-05-01',
            name: 'Tom',
            address: 'No. 189, Grove St, Los Angeles',
          },
        ],
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
      })
      // 打开
      const handleOpen = (row = {}, qrCodeParams, noQrcode, h5Url) => {
        state.row = row
        state.dialogFormVisible = true
      }
      // 关闭
      const handleClose = () => {
        state.dialogFormVisible = false
      }

      return {
        ...toRefs(state),
        handleOpen,
        handleClose,
      }
    },
  })
</script>

<style lang="scss">
  .userInfoDrawer {
    .el-transfer-panel {
      width: 250px;
    }
    .hideLabel {
      .el-descriptions__label {
        display: none;
      }
    }
  }
</style>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }

  .demo-drawer__content {
    height: 85vh;
    overflow: auto;
  }
  .containerForm {
    height: 85vh;
    overflow-y: auto;
  }
  .demo-drawer__footer {
    position: fixed;
    right: 20px;
    bottom: 10px;
  }
  .margin-top {
    margin-top: 20px;
  }
</style>
